export const ROLE_ADMIN = "ADMIN"
export const ROLE_USER = "USER"
export const ROLE_ACCOUNTING = "ACCOUNTING"
export const ROLE_SALE = "SALE"
export const ROLE_WAREHOUSE = "WAREHOUSE"
export const ROLE_TRAINER = "TRAINER"
export const ROLE_VIP = "VIP"
export const ROLE_PRODUCT_MANAGER = "PRODUCT_MANAGER"
